export default {
	// Disable the feedback button in the bottom right
	NO_FEEDBACK: "noFeedback",

	// Disable the Ask PerformYard button in the bottom right
	NO_ASK_PERFORMYARD: "noAskPerformYard",

	//
	SETTINGS: "settings",

	// Auto populates the feedback about input with the current user
	USER_PAGE: "userpage",

	// Will force the page to do a hard page load
	USES_TEMPLATE: "usesTemplate",

	// Triggers template full reload while keeping React visible
	USES_TEMPLATE_AND_REACT: "usesTemplateAndReact",

	// Shows the admin nav
	SHOW_ADMIN_NAV: "showAdminNav",

	// Hides the admin nav (wins over SHOW_ADMIN_NAV and the /administration path fallback).
	// Use for full-focus routes like the Competencies create/edit pages.
	HIDE_ADMIN_NAV: "hideAdminNav",

	// Marks the review form-builder route. Ask PerformYard opens question-suggestion
	// mode when this tag is present on the current match.
	FORM_BUILDER: "formBuilder",

	// Marks the review form-authoring route (/review/:reviewID/), where an employee fills
	// out a review form. The Form Authoring Coach callout only surfaces on this tag.
	FORM_AUTHORING: "formAuthoring",

	// Marks the competency page route. Ask PerformYard opens competency-suggestion
	// mode when this tag is present on the current match.
	COMPETENCIES_ADMIN: "competenciesAdmin",
};
